import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
    name: 'lxFormat',
    standalone: true,
})
export class LuxonToFormatPipe implements PipeTransform {
  transform(value: number | string | DateTime, format: string, opts?: Intl.DateTimeFormatOptions): string {
    let dateTime: DateTime;

    if (!value) {
      return '';
    }

    if (typeof value === 'string') {
      dateTime = DateTime.fromISO(value);
    } else if (typeof value === 'number') {
      dateTime = DateTime.fromMillis(value);
    } else {
      dateTime = value;
    }

    if (!DateTime.isDateTime(dateTime) || !dateTime.isValid) {
      console.warn(`Invalid input to lxToFormat: ${value}`);
      return '';
    }

    return dateTime.toFormat(format, opts);
  }
}
